import HappeningEvents from 'components/Content/Happening/HappeningEvents/HappeningEvents';
import { withHappeningEventsProps } from 'viewModel/content/happening/withHappeningEventsProps';

export default withHappeningEventsProps(HappeningEvents);
